import { newLoanConstants, userConstants, registrationConstants, workflowConstants } from "../_constants";
import { history } from "../_helpers";
import { newLoanService, LeadService, userService, workflowService, ServiceUtil, SessionService, ProfileApi, FinancialService, ProfileService, metadataService } from "../_services";
import guid from '../utils/guid';

export const newLoanActions = {
    findABranch,
    newLoanApp,
    newLoanAppByLeadId,
    preApproval,
    //preApproved,
    enterPersonalInfo,
    sendToLoginEmailInUse,
    sendToLoginHashInUse,
    sendToLoginReCaptchaFailed,
    error,
    validationFail,
    validationPass,
    confirmation,
    tokenValidationFailure,
    newLoanTokenValidationSuccess,
    validateState,
    loanAmount,
    handleLoanAmountBack,
    newLoanTokenValidationFailure,
    handleNewLoanMenuClick,
    handlePersonalInformationRequest,
    handleFinancialInformationRequest,
    unexpectedError,
    accountNotFound,
    saveUserBasisData,
    handleFundingRequest,
    sendNotificationEmail,
    checkForUserHash,
    personalInfoErrorChecker,
    createIDVisionModel,
    //saveExtendedUserProfile Not used

};

function handleNewLoanMenuClick() {
    return dispatch => {
        const branchId = ServiceUtil.getLocalBranchId();
        if(branchId){           
            SessionService.setFundingInformation({
                BranchId:  branchId,
                FundDelivery: metadataService.fundDeliveryType.InStore,
            });
        }
        workflowService.startWorkflow(workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW, dispatch, request, failure);
    };

    function request() {
        sessionStorage.removeItem("requestSubmitted");
      
        return {
            type: newLoanConstants.NEW_LOAN_APP_LOGGED_IN_REQUEST
        };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_APP_LOGGED_IN_FAILURE, errorString };
    }
}

function handlePersonalInformationRequest(personalInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, personalInformation);
    };

    function request(personalInformation) {

        SessionService.setPersonalInfo(personalInformation)
        return {
            type: newLoanConstants.NEW_LOAN_PERSONAL_INFORMATION_REQUEST, personalInformation
        };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_PERSONAL_INFORMATION_FAILURE, errorString };
    }
}

function handleFinancialInformationRequest(financialInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, financialInformation);
    };

    function request(financialInformation) {
        //SessionService.setFinancialInfo(financialInformation);
        return { type: newLoanConstants.NEW_LOAN_FINANCIAL_INFORMATION_REQUEST, financialInformation };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_FINANCIAL_INFORMATION_FAILURE, errorString };
    }

}

function handleFundingRequest(fundingInfo) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, fundingInfo);
    };

    function request(fundingInfo) {
        let bankingAccountNumber = fundingInfo.BankAccountNumber;
        let bankRoutingNumber = fundingInfo.BankRoutingNumber;

        fundingInfo = {
            BranchId: fundingInfo.BranchId,
            FundDelivery: fundingInfo.FundDelivery,
            InstantFunding : fundingInfo.InstantFunding
        };
         
        SessionService.setFundingInformation(fundingInfo)
        return { type: newLoanConstants.NEW_LOAN_FUNDING_REQUEST, bankingAccountNumber, bankRoutingNumber };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_FUNDING_FAILURE, errorString };
    }
}

function findABranch(branchId, branchDetails) {
    return dispatch => {
        try {
            dispatch(request(branchId, branchDetails));
            history.push("/NewLoanApp");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request(branchid) {
        return { type: newLoanConstants.FIND_AN_OFFICE_REQUEST, branchId, branchDetails };
    }

    function failure(errorString) {
        return { type: newLoanConstants.FIND_AN_OFFICE_FAILURE, errorString };
    }
}

function error(errorString) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_APP_FAILURE, errorString });
    };
}

function validationFail(errorString, branchId, branchDetails,) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_VALIDATION_FAIL, errorString, branchId, branchDetails });
    };
}

function validationPass(branchId, branchDetails,) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_VALIDATION_PASS, branchId, branchDetails,});
    };
}

function confirmation() {
    return dispatch => {
        dispatch({ type: newLoanConstants.CONFIRMATION_SUMMARY_REQUEST });
        if(userService.getCurrentUser()){
            history.push("/my-account")
        }
        else{
            history.push("/LogInMain");
        }
    };

}

function createUserBasisData() {

    var user = userService.getCurrentUser(); 
    let registrationPersonalInfo = SessionService.getPersonalInfo();
    // need a user or an email to save the basis
    if (user === null && registrationPersonalInfo === null) {
        return;
    }
     
    // let financialInformation = SessionService.getFinancialInfo(); 
    // if (financialInformation === null) {
    //     return;
    // }

    return {
        UserId: user != null ? user.userId : "",
        UserHash: registrationPersonalInfo.userHash,
        Address1: registrationPersonalInfo.address,
        Address2: registrationPersonalInfo.address2,
        City: registrationPersonalInfo.city,
        State: registrationPersonalInfo.userState,
        PostalCode: registrationPersonalInfo.zipCode,
        YearsAtResidence: registrationPersonalInfo.yearsInHome,
        MonthsAtResidence: registrationPersonalInfo.monthsInHome,
        OwnResidence: registrationPersonalInfo.rentOrOwn
            ? registrationPersonalInfo.rentOrOwn > 0
            ? true
            : false
            : false,
        MonthlyResidencePayment: registrationPersonalInfo.monthlyResidencePayment,
        //LeadId { get; set; }
        Email: registrationPersonalInfo.email,
        DateOfBirth: registrationPersonalInfo.dateOfBirth,
        IdentificationNumber: registrationPersonalInfo.socialSecurityNumber
            ? registrationPersonalInfo.socialSecurityNumber
            : registrationPersonalInfo.individualTaxIdentificationNumber,
        // IncomePerPeriod: financialInformation.incomePerPeriod,
        // PrimaryIncome: financialInformation.primaryIncome,
        // PayFrequency: financialInformation.payFrequency,
        // OtherIncomeSource: financialInformation.otherIncomeSource,
        // MonthlyOtherIncome: financialInformation.monthlyOtherIncome,
        // YearsAtEmployer: financialInformation.yearsAtEmployer,
        // MonthsAtEmployer: financialInformation.monthsAtEmployer,
        // WorkNumber: financialInformation.workNumber,
        // Employer: financialInformation.employer,
        // EmployerStreetAddress: financialInformation.employerStreetAddress,
        // EmployerStreetAddress2: financialInformation.employerStreetAddress2,
        // EmployerCity: financialInformation.employerCity,
        // EmployerState: financialInformation.employerState,
        // EmployerPostalCode: financialInformation.employerPostalCode
    }; 
}
// function saveExtendedUserProfile() {
//     return dispatch => {
//         try {
//             const userProfileExtended = ProfileService.getUserProfileExtendedFromNewLoanRequest();
//             if(userProfileExtended) {
//                 ProfileApi.saveExtendedUserProfile(userProfileExtended).then(
//                     response => {
//                         if (response.httpResponseCode !== 200) {
//                             dispatch(failure(response.message));
//                         } 
//                     },
//                     error => {
//                         dispatch(failure(error));
//                     } 
//                 );
//             }
//         } catch (errorString) { 
//             console.error("saveExtendedUserProfile", errorString)
//             dispatch(failure(errorString));
//         }
//     } 
//     function failure(errorString) {
//         return { type: newLoanConstants.NEW_LOAN_APP_FAILURE, errorString };
//     }
// }
function saveUserBasisData() {
     
    return dispatch => {
        try {
            let basisData = createUserBasisData();
            if(basisData) {
                newLoanService.saveUserBasisData(basisData).then(
                    response => {
                        if (response.httpResponseCode !== 200) {
                            dispatch(failure(response.message));
                        } 
                    },
                    error => {
                        dispatch(failure(error));
                    } 
                );
            }
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    } 
    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_APP_FAILURE, errorString };
    }
}

function createIDVisionModel(newLoan) {
    return {
        SessionId: JSON.parse(sessionStorage.getItem("trustevId")),
        CustomerFirstName: newLoan.firstName,
        CustomerLastName: newLoan.lastName,
        CustomerPersonalIdentifier: newLoan.personalIdentificationNumber,
        CustomerEmail: newLoan.email,
        CustomerAddress1: newLoan.addresses[0].address1,
        CustomerAddress2: newLoan.addresses[0].address2,
        CustomerCity: newLoan.addresses[0].city,
        CustomerState: newLoan.addresses[0].state,
        CustomerPostalCode: newLoan.addresses[0].postalCode,
        CustomerDOB: newLoan.dateOfBirth
    }
}

function newLoanApp(newLoan) {
    var branchDetails = newLoan.BranchDetails;
    return dispatch => {
        try {
            dispatch(request(newLoan.branchId, newLoan.BranchDetails));
            var model = createIDVisionModel(newLoan);
            ServiceUtil.getTrustevIDVisionResult(model).then(idVisionResult => {
                if (idVisionResult) {
                    newLoan.DigitalVerificationCase = idVisionResult.caseId;
                    newLoan.Verification = idVisionResult.verification;
                } else {
                    newLoan.Verification = 0; //unknown verification status
                }
                 
                newLoanService.newLoan(newLoan).then(
                    response => {
                        //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                        if (response.httpResponseCode !== 200) {
                            dispatch(failure(response.message, newLoan.BranchDetails));
                        }

                        //update the store that the response was a success 
                        //clean the store for the new loan except forthe branch details which needs to be shown on the confirmation page
                        let branchInfo = {
                            BranchDetails: newLoan.BranchDetails,
                            BranchId: newLoan.BranchId
                        };
                        let workflowData = workflowService.getCurrentWorkflowStepData()
                        if (workflowData.workflowId === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW) {
                            workflowService.nextStep(dispatch, newLoanResponse, failure, branchInfo);
                        } else {
                            workflowService.startWorkflow(workflowConstants.APPLICATION_RECEIVED_WORKFLOW, dispatch, newLoanResponse, failure, branchInfo);
                        }
                    },
                    error => {
                        dispatch(failure(error, newLoan.BranchDetails));
                    }
                );
            });

        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request(branchId, branchDetails) {
        return {
            type: newLoanConstants.NEW_LOAN_APP_REQUEST, branchId, branchDetails };
    }

    function newLoanResponse(branchInfo) {
        let requestSubmitted = { RequestAlreadySubmitted: true };
        sessionStorage.setItem("requestSubmitted", JSON.stringify(requestSubmitted));
        return {
            type: newLoanConstants.NEW_LOAN_APP_SUCCESS, branchDetails: branchInfo.BranchDetails, BranchId: branchInfo.BranchId
        };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_APP_FAILURE, errorString, branchDetails };
    }
}

function newLoanAppByLeadId(newLoan) {
    return dispatch => {
        try {

            dispatch(request(newLoan));

            var model = createIDVisionModel(newLoan);
            ServiceUtil.getTrustevIDVisionResult(model).then(idVisionResult => {
                if (idVisionResult) {
                    newLoan.DigitalVerificationCase = idVisionResult.caseId;
                    newLoan.Verification = idVisionResult.verification;
                } else {
                    newLoan.Verification = 0; //unknown verification status
                }
                newLoanService.newLoanByLeadId(newLoan).then(
                    response => {
                        //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                        if (response.httpResponseCode !== 200) {
                            dispatch(failure(response.message, newLoan.LeadId));
                        }
                        else {
                            userService.isEmailInUse(newLoan.Email).then(emailInUse => {

                                if (emailInUse.data) {
                                    history.push("/LoanSubmittedConfirmation");
                                }
                                else {
                                    //update the store that the response was a success 
                                    //clean the store for the new loan except forthe branch details which needs to be shown on the confirmation page
                                    let branchInfo = {
                                        branchDetails: newLoan.branchDetails, BranchId: newLoan.BranchId
                                    };
                                    workflowService.startWorkflow(workflowConstants.APPLICATION_RECEIVED_WORKFLOW, dispatch, newLoanResponse, failure,branchInfo);  
                                    //workflowService.nextStep(dispatch, newLoanResponse, failure, branchInfo);
                                }
                            });
                        }
                    },
                    error => {
                        dispatch(failure(error, newLoan.LeadId));
                    }
                );
            });
        } catch (errorString) {
            dispatch(failure(errorString, newLoan.LeadId));
        }
    };

    function request(newLoan) {
        return {
            type: newLoanConstants.NEW_LOAN_APP_REQUEST, newLoan
        };
    }

    function newLoanResponse(branchInfo) {
        let requestSubmitted = { RequestAlreadySubmitted: true };
        sessionStorage.setItem("requestSubmitted", JSON.stringify(requestSubmitted));
        return {
            type: newLoanConstants.NEW_LOAN_APP_SUCCESS, branchDetails: branchInfo.branchDetails, BranchId: branchInfo.BranchId
        };
    }

    function failure(errorString, leadId) {
        return { type: newLoanConstants.NEW_LOAN_APP_FAILURE, errorString, leadId };
    }
}

function preApproval() {
    return dispatch => {
        dispatch({ type: newLoanConstants.PRE_APPROVAL_REQUEST });
        history.push("/PreApproval");
    };
}

function enterPersonalInfo(newLoan) {
    const { firstName, lastName, email, mobilePhoneNumber, borrowerState, requestedAmount, preApprovalCode } = newLoan

    const personalInfo = {
        firstName: newLoan.firstName,
        lastName: newLoan.lastName,
        email: newLoan.email,
        mobilePhoneNumber: newLoan.mobilePhoneNumber,
        borrowerState: newLoan.borrowerState,
        requestedAmount: newLoan.requestedAmount,
        preApprovalCode: newLoan.preApprovalCode,
    }


    return dispatch => {
        dispatch({ type: registrationConstants.NEW_CUSTOMER_REQUEST, firstName, lastName, email, mobilePhoneNumber, borrowerState, requestedAmount, preApprovalCode });
        SessionService.setPersonalInfo(personalInfo)
        history.push("/PersonalInfo");

    };
}

function sendToLoginEmailInUse() {
    return dispatch => {
        dispatch({ type: userConstants.EMAIL_IN_USE });
        history.push("/LogInMain");
    };
}
function sendToLoginHashInUse() {

    SessionService.clearSession();
     
    sessionStorage.removeItem("workFlowData");

    sessionStorage.setItem("userHashMatch_login", true); 
    return dispatch => {
        dispatch({ type: userConstants.USER_HASH_IN_USE });
        history.push("/LogInMain");
    };
}

function sendToLoginReCaptchaFailed() {
    return dispatch => {
        dispatch({ type: userConstants.RECAPTCHA_FAILED });
        history.push("/LogInMain");
    };
}

function newLoanTokenValidationSuccess(leadByToken) {
    return dispatch => {
        workflowService.startWorkflow(workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW, dispatch, request, failure, leadByToken);
    };

    function request(leadByToken) {
        SessionService.clearSession();
        var personalInfo = {
            firstName: leadByToken.firstName,
            lastName: leadByToken.lastName,
            address1: leadByToken.address1,
            address2: leadByToken.address2,
            city: leadByToken.city,
            postalCode: leadByToken.postalCode,
            state: leadByToken.state,
            email: leadByToken.email,
            years: leadByToken.yearsAtResidence ? leadByToken.yearsAtResidence.toString() : "",
            months: leadByToken.monthsAtResidence ? leadByToken.monthsAtResidence.toString() : "",
            residenceType: leadByToken.ownResidence == true ? 1 : 0,
            monthlyResidencePayment: leadByToken.monthlyResidencePayment ? leadByToken.monthlyResidencePayment.toString() : "",
            mobileNumber: leadByToken.mobileNumber,
            dateOfBirth: leadByToken.dateOfBirth,
            requestedAmount: leadByToken.preApprovalOffer != undefined ? leadByToken.preApprovalOffer : leadByToken.requestedAmount,
            userHash: leadByToken.userHash,
            branchId: leadByToken.branchId,
        };

        leadByToken.employments.forEach(employer => {
            employer.id = guid();
            employer.isAdd = true;
            SessionService.addEmployer(employer)     
        });

        leadByToken.incomes.forEach(income => {
            income.id = guid();
            income.isAdd = true;
            income.otherIncomeSource = income.incomeSource; // Todo: Refactor this line later. (create helper method for purchaselead before adding to sessionStorage.)
            SessionService.addIncome(income)
        });

        SessionService.setPersonalInfo(personalInfo);

        return { type: newLoanConstants.NEW_LOAN_TOKEN_SUCCESS, leadByToken };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_TOKEN_FAILURE, errorString };
    }
}

function newLoanTokenValidationFailure(errorString) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_TOKEN_FAILURE, errorString });
        history.push("/Error");
    };
}

function tokenValidationFailure(errorString) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_UPLOAD_TOKEN_FAILURE, errorString });
        history.push("/Error");
    };
}

function unexpectedError(errorString) {
    return dispatch => {
        dispatch({ type: newLoanConstants.NEW_LOAN_UPLOAD_TOKEN_FAILURE, errorString });
        history.push("/Error");
    };
}

function accountNotFound(errorString) {
    return dispatch => {
        dispatch({ type: newLoanConstants.ACCOUNT_NOT_FOUND, errorString });
        history.push("/Error");
    };
}

async function validateState(incompleteLead, dispatch) {

    sessionStorage.removeItem("stateLoanInfo");

    //always send incomplete lead now
    LeadService.sendIncompleteLead(incompleteLead);

    var businessState = {
        stateData: {
            doesBusinessInState: false
        }
    };

    await newLoanService.validateState(incompleteLead.state).then(
        response => {                      
            if (response.httpResponseCode !== 200) {
                var errorMessage = response.message;
                dispatch({ type: newLoanConstants.VALIDATE_STATE_FAILURE, errorMessage });
                history.push("/Error");
            } else {
                var stateData = response.data;
                businessState = { type: newLoanConstants.VALIDATE_STATE_SUCCESS, stateData };
                if (businessState.stateData.doesBusinessInState) {
                    sessionStorage.setItem("stateLoanInfo", JSON.stringify(businessState.stateData));
                }
            }
        }
    );

    return businessState.stateData;
}

function loanAmount(cashNeeded) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, cashNeeded);
    };

    function request(cashNeeded) {

        let registrationPersonalInfo = SessionService.getPersonalInfo();

        registrationPersonalInfo.requestedAmount = cashNeeded;
        SessionService.setPersonalInfo(registrationPersonalInfo)        

        return { type: newLoanConstants.NEW_LOAN_AMOUNT_REQUEST };
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_AMOUNT_FAILURE, errorString};
    }
}

function handleLoanAmountBack() {
    return dispatch => {
        workflowService.previousStep(dispatch, request, failure);
    };

    function request() {
        return { type: newLoanConstants.NEW_LOAN_AMOUNT_BACK_REQUEST }
    }

    function failure(errorString) {
        return { type: newLoanConstants.NEW_LOAN_AMOUNT_BACK_FAILURE, errorString };

    }
}

function sendNotificationEmail(email, userHash, languagePreference) { 
    let data = { "email": email, "userHash": userHash, "languagePreference": languagePreference}; 
            newLoanService.sendNotificationEmail(data).then(
                response => {
                    if (response.httpResponseCode !== 200) {
                        console.log('failure sending email');
                    }
                }
            ); 
        } 

async function checkForUserHash(userHash) { 
    //user is not logged in, so it is not a change request
    //if it is a new loan for an old user, make them log in first
    //this would have been caught by email check at front, but
    //the user has used a different/new email
    if (!userService.getCurrentUser()) {
        let match = await userService.isHashInUse(userHash).then(
            response => {
                if (response.httpResponseCode !== 200) {
                    return true;
                }
                else if (response.data === true) {
                    return true;
                }
                else {
                    return false;
                }
            },
            error => {
                return true;
            }
        );
        return match;
    };
    return false;
}

function personalInfoErrorChecker(errorState) {
    return {type: newLoanConstants.PERSONAL_INFO_ERROR_CHECK, errorState}
}




// WEBPACK FOOTER //
// ./src/_actions/newloan.actions.js